import {
  CameraFilled,
  CheckOutlined,
  FolderOpenOutlined,
  LineOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { Col, Row, Image, Button } from "antd";

import rombergBase from "../images/front_b_rotate.png";
import rombergLato from "../images/right_b_rotate.png";
import TestUI from "./TestUI";
import { PosturalExamination, PosturalTestDefinition } from "./interfaces";
import { photoNotTakenYet, TakenPhoto } from "./PosturalExamWrapper";
import { useEffect, useRef } from "react";
import TinettiExam from "./TinettiExam";

const PosturalExamTinettiRight = ({
  page,
  testDefinitions,
  posturalExamination,
  setTestSelection,
  justCreated,
}: {
  page: number;
  testDefinitions: PosturalTestDefinition[];
  posturalExamination: PosturalExamination;
  setTestSelection: Function;
  justCreated: boolean;
}) => {
  if (testDefinitions && testDefinitions.length > 0)
    testDefinitions.sort((td1, td2) => td1.id - td2.id);

  console.log("i'm in tinetti test");

  console.log("questa è la selezione: " + testDefinitions[2]);
  return (
    <>
      {page == 0 && (
        <>
          <div>
            <TinettiExam />
          </div>
        </>
      )}
      {page == 1 && (
        <>
          <TestUI
            testDefinition={
              testDefinitions.length > 0 ? testDefinitions[0] : undefined
            }
            testSelection={
              posturalExamination.testSelections &&
              posturalExamination.testSelections.length > 0
                ? posturalExamination.testSelections[0]
                : undefined
            }
            setTestSelection={setTestSelection}
          />
        </>
      )}
    </>
  );
};
export default PosturalExamTinettiRight;
